import React from "react";
import { Typography, Divider, Card, Button, Row, Col } from "antd";
import { useNavigate } from "react-router-dom";
import {
  ArrowRightOutlined,
  LinkOutlined,
  CaretRightFilled,
} from "@ant-design/icons";
import industryFashionImage from "../assets/industry-fashion.png";
import industryCallUs from "../assets/industry-call.png";

const { Title, Paragraph, Text } = Typography;

const Industry = () => {
  return (
    <div style={{ marginTop: "110px", background: "white" }}>
      <div
        className="industries-title-overlay"
        data-aos="fade-down"
        data-aos-duration="700"
        style={{ background: `url(${industryFashionImage})` }}
      >
        <div className="industries-hero-title">Industries We Serve</div>
        <div className="industries-hero-subtitle">
          {" "}
          At clover bay technologies, we empower businesses across various
          sectors to achieve digital transformation and operational excellence.
        </div>
      </div>
      <div
        className="section-content service-main-dev"
        style={{ paddingTop: "50px" }}
      >
        <Row>
          <Col lg={8}>
            <Card className="industry-navbar">
              <div className="industry-navbar-title">Industries</div>
              <div className="industry-nav-card">
                <div className="industry-nav-title">Grocery</div>
              </div>
              <div className="industry-nav-card">
                <div className="industry-nav-title">Fashion</div>
              </div>
              <div className="industry-nav-card">
                <div className="industry-nav-title">Electronics</div>
              </div>
              <div className="industry-nav-card">
                <div className="industry-nav-title">Automotive</div>
              </div>
              <div className="industry-nav-card">
                <div className="industry-nav-title">Healthcare</div>
              </div>
            </Card>
            <div>
              <img src={industryCallUs} />
            </div>
          </Col>
          <Col lg={16}></Col>
        </Row>
      </div>
    </div>
  );
};
export default Industry;
